"use strict";

var _classCallCheck = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Geography = exports.CardinalDirection = exports.METERS_PER_MILE = exports.EARTH_RADIUS_METERS = exports.DEGREES_PER_PI = void 0;
exports.DEGREES_PER_PI = 180;
exports.EARTH_RADIUS_METERS = 6378137;
exports.METERS_PER_MILE = 1609.34;

var isNil = function isNil(value) {
  return value == null;
};

var CardinalDirection;

(function (CardinalDirection) {
  CardinalDirection[CardinalDirection["NORTH"] = 0] = "NORTH";
  CardinalDirection[CardinalDirection["EAST"] = 90] = "EAST";
  CardinalDirection[CardinalDirection["SOUTH"] = 180] = "SOUTH";
  CardinalDirection[CardinalDirection["WEST"] = 270] = "WEST";
})(CardinalDirection = exports.CardinalDirection || (exports.CardinalDirection = {}));
/**
 * The Geography class provides a set of convenience methods for working with Earth's geography.
 */


var Geography = /*#__PURE__*/function () {
  function Geography() {
    _classCallCheck(this, Geography);
  }

  _createClass(Geography, null, [{
    key: "coordinateAtDistanceAndBearing",

    /**
     * Given a starting point lat/lng, a bearing in degrees and distance,
     * calculates the resulting lat/lng using reverse haversine
     *
     * @param {ICoordinateAtDistanceAndBearing} options
     * * bearing - the angle bearing for the desired, new point.
     * * distance - the distance in meters to the desired, new point.
     * * lat - the latitude of starting point.
     * * lng - the longitude of starting point.
     *
     * @returns {ILocation}
     * The lat/lng coordinates in degrees, calculated from given parameters.
     */
    value: function coordinateAtDistanceAndBearing(_ref) {
      var bearing = _ref.bearing,
          distance = _ref.distance,
          lat = _ref.lat,
          lng = _ref.lng;
      var lat1 = this.toRadians(lat);
      var lng1 = this.toRadians(lng);
      var angularDistance = distance / exports.EARTH_RADIUS_METERS;
      var lat2 = Math.asin(Math.sin(lat1) * Math.cos(angularDistance) + Math.cos(lat1) * Math.sin(angularDistance) * Math.cos(bearing));
      var lng2 = lng1 + Math.atan2(Math.sin(bearing) * Math.sin(angularDistance) * Math.cos(lat1), Math.cos(angularDistance) - Math.sin(lat1) * Math.sin(lat2));
      return {
        lat: this.toDegrees(lat2),
        lng: this.toDegrees(lng2)
      };
    }
    /**
     * Compute the distance between two sets of coordinates, defined using latitude and longitude.
     * By default, the distance is computed in miles.
     *
     * See https://www.movable-type.co.uk/scripts/latlong.html
     *
     * @param {ICoordinates} point1
     * The first set of coordinates.
     *
     * @param {ICoordinates} point2
     * The second set of coordinates.
     *
     * @param {boolean} inMiles
     * Optionally return the distance in miles.
     *
     * @returns {number}
     * The distance between the two sets of coordinates.
     */

  }, {
    key: "coordinateDistance",
    value: function coordinateDistance(point1, point2) {
      var inMiles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      // convert the latitude values to radians
      var latitude1 = this.toRadians(point1.latitude);
      var latitude2 = this.toRadians(point2.latitude); // compute the delta of latitude and longitude, in radians

      var latitudeDelta = this.toRadians(point2.latitude - point1.latitude);
      var longitudeDelta = this.toRadians(point2.longitude - point1.longitude);
      /* eslint-disable @typescript-eslint/no-magic-numbers */

      var a = Math.pow(Math.sin(latitudeDelta / 2), 2) + Math.cos(latitude1) * Math.cos(latitude2) * Math.pow(Math.sin(longitudeDelta / 2), 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      /* eslint-enable @typescript-eslint/no-magic-numbers */

      var distance = exports.EARTH_RADIUS_METERS * c;
      return inMiles ? this.toMiles(distance) : distance;
    }
    /**
     * Given a starting point latitude/longitude and a distance,
     * calculates the minimum and maximum latitude/longitude
     *
     * @param {IBoundCoordinates} coordinates
     * * distance - the distance in meters to the desired, new point.
     * * lat - the latitude of starting point.
     * * lng - the longitude of starting point.
     *
     * @returns {IMinMaxBounds}
     * The minimum and maximum latitude/longitude
     */

  }, {
    key: "getBounds",
    value: function getBounds(coordinates) {
      var distance = coordinates.distance,
          lat = coordinates.lat,
          lng = coordinates.lng;

      if (isNil(lat) || isNil(lng) || isNil(distance)) {
        return null;
      }

      var _this$coordinateAtDis = this.coordinateAtDistanceAndBearing({
        bearing: this.toRadians(CardinalDirection.NORTH),
        distance: distance,
        lat: lat,
        lng: lng
      }),
          maxLat = _this$coordinateAtDis.lat;

      var _this$coordinateAtDis2 = this.coordinateAtDistanceAndBearing({
        bearing: this.toRadians(CardinalDirection.EAST),
        distance: distance,
        lat: lat,
        lng: lng
      }),
          maxLng = _this$coordinateAtDis2.lng;

      var _this$coordinateAtDis3 = this.coordinateAtDistanceAndBearing({
        bearing: this.toRadians(CardinalDirection.SOUTH),
        distance: distance,
        lat: lat,
        lng: lng
      }),
          minLat = _this$coordinateAtDis3.lat;

      var _this$coordinateAtDis4 = this.coordinateAtDistanceAndBearing({
        bearing: this.toRadians(CardinalDirection.WEST),
        distance: distance,
        lat: lat,
        lng: lng
      }),
          minLng = _this$coordinateAtDis4.lng;

      return {
        maxLat: maxLat,
        maxLng: maxLng,
        minLat: minLat,
        minLng: minLng
      };
    }
    /**
     * Convert radians to degrees.
     *
     * @param {number} radians
     * The value, in radians, to convert to degrees.
     *
     * @returns {number}
     * The value, in degrees, converted from degrees.
     */

  }, {
    key: "toDegrees",
    value: function toDegrees(radians) {
      return radians * (exports.DEGREES_PER_PI / Math.PI);
    }
    /**
     * Convert meters to miles.
     *
     * @param {number} meters
     * The value, in meters to convert to miles.
     *
     * @returns {number}
     * The value, in meters converted to miles.
     */

  }, {
    key: "toMiles",
    value: function toMiles(meters) {
      return meters / exports.METERS_PER_MILE;
    }
    /**
     * Convert degrees to radians.
     *
     * @param {number} degrees
     * The value, in degrees to convert to radians.
     *
     * @returns {number}
     * The value, in degrees converted to radians.
     */

  }, {
    key: "toRadians",
    value: function toRadians(degrees) {
      return degrees * (Math.PI / exports.DEGREES_PER_PI);
    }
  }]);

  return Geography;
}();

exports.Geography = Geography;